import React            from 'react';
import PropTypes        from 'prop-types';
import { Header, Grid } from 'semantic-ui-react';

import AffiliationStatus  from './AffiliationStatus';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const ParticipantView = ({ affiliation }) => {
  const { name } = affiliation;
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <Header as='h2'>
            Affiliation request from { name }
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <AffiliationStatus affiliation={ affiliation } />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

ParticipantView.defaultProps = {

};

ParticipantView.propTypes = {
  affiliation: PropTypes.object.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default ParticipantView;
